import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import RightTimeApi from "@/API";
import Enums from "@/enums";
import { toast } from "react-toastify";

type JobRow = {
  id: number;
  name: string;
  departmentIds?: number[];
};

export default function DepartmentJobsTable(props: {
  department: { id: number; name: string };
  jobs?: JobRow[];
  adminPerms?: number[];
  refreshDepartments: () => Promise<unknown>;
}) {
  const { department, jobs = [], adminPerms, refreshDepartments } = props;
  const canEdit =
    adminPerms?.includes(Enums.ROLE_PERMS.EditJobs) ||
    adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin) ||
    adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin);

  async function toggleJobAsync(jobId: number) {
    if (!canEdit) return;
    const resp = await RightTimeApi.putAsync(`/CompanyDepartment/${department.id}/Job/${jobId}/Toggle`, {});
    if (resp?.ok) {
      await refreshDepartments();
    } else {
      toast.error("Failed to update job department assignment.");
    }
  }

  const sortedJobs = [...jobs].sort((a, b) => {
    const aChecked = (a.departmentIds ?? []).includes(department.id);
    const bChecked = (b.departmentIds ?? []).includes(department.id);
    if (aChecked !== bChecked) return aChecked ? -1 : 1;
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="tableWrapper factTable horizontal scrollable departmentJobsTable">
      <table>
        <caption>
          <span className="title">{department.name} / Jobs</span>
        </caption>
        <thead>
          <tr>
            <th>Job</th>
            <th className="toggleColumnHeader">Assigned</th>
          </tr>
        </thead>
        <tbody>
          {sortedJobs.map((job) => {
            const isAssigned = (job.departmentIds ?? []).includes(department.id);
            return (
              <tr key={`dept-job-${job.id}`}>
                <td className="left">{job.name}</td>
                <td
                  className="actions center"
                  onClick={() => {
                    if (canEdit) toggleJobAsync(job.id);
                  }}
                >
                  {isAssigned ? (
                    <MdCheckBox className={`checkbox checked actionIcon${canEdit ? "" : " disabled"}`} />
                  ) : (
                    <MdCheckBoxOutlineBlank className={`checkbox unchecked actionIcon${canEdit ? "" : " disabled"}`} />
                  )}
                </td>
              </tr>
            );
          })}
          {sortedJobs.length === 0 ? (
            <tr>
              <td colSpan={2} className="center">No jobs available</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
